/* System defined core library */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as $ from 'jquery';

/* User defined library/components */
import { AppModule } from './app/app.module';
import { BootstrapParams } from './bootstrap-params';


const isLocal = window.location.href.indexOf('localhost');

if (isLocal < 0) {
  enableProdMode();
}

window['bootstrapApp'] = function (apiUrl: string,
  googleMapKey: string,
  bingMapKey: string,
  bingMapCountryFilter: string,
  useBingMaps: boolean,
  messagingRootApiUrl: string,
  registrationRootApiUrl: string,
  orchestrationRootApiUrl: string,
  paymentRootApiUrl: string,
  metricRootApiUrl: string,
  lpiParams: string,
  sessionTime: string,
  expiresIn: string,
  token: string,
  refreshPriorExp: string,
  googleRegion: string,
  candidateGuid: string,
  cmsUrl: string,
  clientCode: string,
  seatTimer: string,
  longSeatTimer: string,
  longSeatTimerClients: string,
  candidateLastName: string,
  legacyCancel: boolean,
  logConsoleToDB: boolean,
  hideBiometricsClients: string,
  sessionGuid: string,
  hiddenClient: boolean,
  extendHoldTime: string,
  failedLibs: any,
  proctorTakeSize: string,
  captchaEnable: boolean,
  defaultSearchDateRange: string,
  testCenterCalendarDays: string,
  testCenterTakeSize: string,
  paymentOrchestratorPollingTime: string,
  paymentOrchestratorPollingLimit: string,
  paymentOrchestratorRetryTime: string,
  paymentOrchestratorMaxRetries: string,
  testingWindowDisplayYears: string,
  displayTaxDisclaimer: boolean,
  volumeGovernanceEnabled: boolean,
  volumeGovernanceAzureFunctionUrl: string,
  volumeGovernanceAzureFunctionKey: string,
  lsacPrograms: string
) {
  let lastName = !!candidateLastName ? $("<textarea/>").html(candidateLastName).text() : candidateLastName;
  lpiParams = !!lpiParams ? $("<textarea/>").html(decodeURIComponent(lpiParams)).text() : lpiParams;

  platformBrowserDynamic([{
    provide: BootstrapParams, useValue: new BootstrapParams(
      apiUrl,
      googleMapKey,
      bingMapKey,
      bingMapCountryFilter,
      useBingMaps,
      messagingRootApiUrl,
      registrationRootApiUrl,
      orchestrationRootApiUrl,
      paymentRootApiUrl,
      metricRootApiUrl,
      lpiParams,
      sessionTime,
      expiresIn,
      token,
      refreshPriorExp,
      googleRegion,
      candidateGuid,
      cmsUrl,
      clientCode,
      seatTimer,
      longSeatTimer,
      longSeatTimerClients,
      lastName,
      legacyCancel,
      logConsoleToDB,
      hideBiometricsClients,
      sessionGuid,
      hiddenClient,
      extendHoldTime,
      failedLibs,
      proctorTakeSize,
      captchaEnable,
      defaultSearchDateRange,
      testCenterCalendarDays,
      testCenterTakeSize,
      paymentOrchestratorPollingTime,
      paymentOrchestratorPollingLimit,
      paymentOrchestratorRetryTime,
      paymentOrchestratorMaxRetries,
      testingWindowDisplayYears,
      displayTaxDisclaimer,
      volumeGovernanceEnabled,
      volumeGovernanceAzureFunctionUrl,
      volumeGovernanceAzureFunctionKey,
      lsacPrograms
    )
  }]).bootstrapModule(AppModule);
};
